import React from "react";
import {
    Autocomplete,
    TextField,
} from "@mui/material";
import "./PublicationFilters.css";

const PublicationFilters = ({ filters, setFilters, publications }) => {
    const categories = [...new Set(publications.map(pub => pub.category))].filter(category => category !== null).sort();
    const journals = [...new Set(publications.map(pub => pub.journal))].filter(journal => journal !== null).sort();
    const years = [...new Set(publications.map(pub => pub.year))].filter(year => year !== null).sort();

    const handleFilterChange = (filterKey, selectedOptions) => {
        setFilters({ ...filters, [filterKey]: selectedOptions });
    };

    return (
        <div className="dataFilterWindow" onClick={(e) => e.stopPropagation()}>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={categories}
                    value={!filters.category ? [] : filters.category}
                    onChange={(_, selectedOptions) => handleFilterChange("category", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Category"}
                            sx={{ ...(filters.category && filters.category.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={journals}
                    value={!filters.journal ? [] : filters.journal}
                    onChange={(_, selectedOptions) => handleFilterChange("journal", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Journal"}
                            sx={{ ...(filters.journal && filters.journal.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={years}
                    value={!filters.year ? [] : filters.year}
                    onChange={(_, selectedOptions) => handleFilterChange("year", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Year"}
                            sx={{ ...(filters.year && filters.year.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
        </div>
    );
}

export default PublicationFilters;